// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/forms/Form.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/forms/Form.tsx");
  import.meta.hot.lastModified = "1740183864614.0354";
}
// REMIX HMR END

import { Form as FrameworkForm, useActionData, useSubmit, useNavigation } from "@remix-run/react";
import { Fragment } from "react";
import { createForm } from "remix-forms";
import { Checkbox, Field, Input, Label, Multiline, Select } from "~/components/forms/fields";
import Button from "~/components/Button";
const BaseForm = createForm({
  component: FrameworkForm,
  useNavigation,
  useSubmit,
  useActionData
});
_c = BaseForm;
function SubmitButton(props) {
  return <Button variant="primary" className="w-full" {...props} />;
}
_c2 = SubmitButton;
function Errors({
  className,
  ...props
}) {
  return <div className="text-sm text-error-600" {...props} />;
}
_c3 = Errors;
function GlobalErrors({
  className,
  ...props
}) {
  return <div className="mt-4 flex justify-center bg-error-600 p-4 children:text-base children:text-white" {...props} />;
}
_c4 = GlobalErrors;
export default function Form(props) {
  return <BaseForm {...props} inputComponent={Input} multilineComponent={Multiline} selectComponent={Select} checkboxComponent={Checkbox} labelComponent={Label} fieldComponent={Field} buttonComponent={SubmitButton} errorComponent={Errors} globalErrorsComponent={GlobalErrors} renderField={({
    Field,
    ...props
  }) => {
    const {
      label,
      fieldType,
      name
    } = props;
    if (fieldType === "boolean") {
      return <Field key={name} {...props}>
              {({
          SmartInput,
          Label,
          Errors
        }) => <Fragment>
                  <fieldset className="flex gap-2">
                    <SmartInput />
                    <Label />
                  </fieldset>
                  <Errors />
                </Fragment>}
            </Field>;
    }
    return <Field key={name} {...props}>
            {({
        SmartInput,
        Errors,
        required
      }) => <Fragment>
                <Label>
                  {label}
                  {required && <sup>*</sup>}
                </Label>
                <SmartInput />
                <Errors />
              </Fragment>}
          </Field>;
  }} />;
}
_c5 = Form;
var _c, _c2, _c3, _c4, _c5;
$RefreshReg$(_c, "BaseForm");
$RefreshReg$(_c2, "SubmitButton");
$RefreshReg$(_c3, "Errors");
$RefreshReg$(_c4, "GlobalErrors");
$RefreshReg$(_c5, "Form");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;